import React, { useState } from "react";
import "./LoginForm.css";
import logoImg from "../../assets/logos/white-logo.svg";
import RegistrationForm from "../RegistrationFormModal/RegistrationForm";
import { AuthService } from "../ApiServices/AuthApi";
import { RoleId } from "../Enum/RoleId";
import Feedback from "../FeedbackModal/Feedback";

import { status } from "nprogress";
import { useNavigate } from "react-router-dom";

function LoginForm({ onClose, showRegister }) {
  const [showRegistration, setShowRegistration] = useState(false);
  const service = AuthService();

  const [FormData, setFormData] = useState({
    Email: "",
    password: "",
  });

  const [showModel, setShowModal] = useState(false);
  const [isSuccess, setisSuccess] = useState(null);

  const navigate = useNavigate();
  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const payload = {
        Email: FormData.Email,
        password: FormData.password,
        role_id: RoleId.User,
      };

      const response = await service.LoginUser(payload);

      if (response.result == 1) {
        setShowModal(true);
        setisSuccess({
          // icon: 'bi bi-check-lg',
          status: "success",
          title: "Success",
          message: "User Login Successfully",
          // delay:3000,
          show: true,
        });

        localStorage.clear();
        let userData = response.result_value;
        console.log("userdata--",  userData);

        localStorage.setItem("expiresAt", JSON.stringify(userData.expiresAt));
        localStorage.setItem("roleId", JSON.stringify(userData.roleId));
        localStorage.setItem("roleName", JSON.stringify(userData.roleName));
        localStorage.setItem("token", JSON.stringify(userData.token));
        localStorage.setItem("userId", JSON.stringify(userData.userId));
        localStorage.setItem("username", userData.username);
        localStorage.setItem("userEmail", userData.email);
        localStorage.setItem("phoneNumber", userData.phoneNumber);
        localStorage.setItem("userProfile", userData.userProfile);

   
        // navigate('/blog', { state: { refresh: Date.now() } });
    
      } else {
        // alert("Login failed: " + response.error_value?.errorText);
        var Error_value = response.error_value.errorText;

        setShowModal(true);
        setisSuccess({
          // icon: 'bi bi-x-lg',
          status: "failure",
          title: "Failed",
          message: Error_value,
          show: true,
        });
      }

      // Reset form
      setFormData({
        Email: "",
        password: "",
      });
    } catch (error) {
      // console.error('Error:', error);
      // alert("Login failed due to network error!");
      setShowModal(true);
      setisSuccess({
        icon: "failure",
        title: "Failed",
        message: error.message,
        show: true,
      });
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  return (
    <>
      <div className="registration_modal_overlay">
        <div className="registration_modal_cross">
          <i className="bi bi-x-lg close_icon" onClick={onClose}></i>
        </div>
        <div className="registration_modal">
          <div className="left-panel">
            <div className="profile">
              <img src={logoImg} alt="Profile" />
              <h3>Tech Features</h3>
              <p>
                At TechFeatures, we’re committed to providing seamless
                technology solutions that empower businesses and individuals
                alike. Create your account to access exclusive insights,
                innovative tools, and personalized support tailored to your
                needs. Your journey towards smarter tech starts here.
              </p>
            </div>
          </div>

          <div className="right-panel">
            <h2>Log In to Your Account</h2>
            <form className="registration-form" onSubmit={handleSubmit}>
              <div>
                <input
                  type="email"
                  name="Email"
                  value={FormData.Email}
                  onChange={handleChange}
                  placeholder="Enter your email"
                  required
                />
              </div>
              <div>
                <input
                  type="password"
                  name="password"
                  value={FormData.password}
                  onChange={handleChange}
                  placeholder="Enter your password"
                  required
                />
              </div>

              <button type="submit" className="btn primary_btn">
                Login Now
              </button>
              <div className="form_line">&</div>
              <p
                className="form_link"
                onClick={() => {
                  setShowRegistration(true);
                  if (typeof showRegister === "function") showRegister();
                }}
                style={{ cursor: "pointer" }}
              >
                Sign up
              </p>
            </form>
          </div>
        </div>
      </div>

      {showRegistration && (
        <RegistrationForm
          onClose={() => setShowRegistration(false)}
        />
      )}

      {showModel && (
        <Feedback
          isSuccess={isSuccess}
          onClose={() => {
            setShowModal(false);
            setisSuccess(null);
            navigate("/blog");
            if (isSuccess && isSuccess.status === "success" && typeof onClose === "function") {
              onClose();
            }
          }}
        />
      )}
    </>
  );
}

export default LoginForm;
